import Vue from 'vue'
import App from './App.vue'
import { router } from './_router'
import { store } from './_store'
import vuetify from './plugins/vuetify';
//@ts-ignore
import VueSignaturePad from 'vue-signature-pad';
//@ts-ignore
import JsonExcel from 'vue-json-excel'
import AssociataFilter from "./_filters/associataFilter";
import ArtigianaFilter from "./_filters/artigianaFilter";
import ArticolazioniFilter from "./_filters/articolazioniFilter";
import IndirizziStudioFilter from "./_filters/indirizziStudioFilter";
import RuoliFilter from "./_filters/ruoliFilter";
import ValutazioneFilter from "./_filters/valutazioneFilter"
//@ts-ignore
import BooleanFilter from "./_filters/booleanFilter"
import UppercaseFilter from "./_filters/uppercaseFilter"
import TipoAttivitaFilter from "./_filters/tipoAttivitaFilter"


Vue.config.productionTip = false

Vue.use(VueSignaturePad);
Vue.component('downloadExcel', JsonExcel)

Vue.filter('associataFilter', AssociataFilter)
Vue.filter('artigianaFilter', ArtigianaFilter)
Vue.filter('articolazioniFilter', ArticolazioniFilter)
Vue.filter('indirizziStudioFilter', IndirizziStudioFilter)
Vue.filter('ruoliFilter', RuoliFilter)
Vue.filter('valutazioneFilter', ValutazioneFilter)
Vue.filter('booleanFilter', BooleanFilter)
Vue.filter('uppercaseFilter', UppercaseFilter)
Vue.filter('tipoAttivitaFilter', TipoAttivitaFilter)

export const bus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
